import { render, staticRenderFns } from "./HomeStart.vue?vue&type=template&id=f9a9aee4&"
import script from "./HomeStart.vue?vue&type=script&lang=js&"
export * from "./HomeStart.vue?vue&type=script&lang=js&"
import style0 from "./HomeStart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports